/*
 * @Author: zhangxu
 * @Date: 2022-05-06 11:18:35
 * @LastEditors: zhangxu
 * @LastEditTime: 2022-06-23 23:23:58
 * @FilePath: /daodao-biz-front/src/components/further/workbench/scheme.ts
 */
import message from '@/shared/message'
import store from '@/store/index'
import {Further} from '@/interface/further.interface'

let state: any, dispatch: any

interface Scheme {
  _getCommonData: {
    (): {
      oldList: Further.ZyFullItem[]
      recommendConf: Further.RecommendConf
      zybConf: Further.ZybConf
    }
  }
  _commitList: { (list: Further.ZyFullItem[], isUndo?: boolean, changeSortType?: boolean): void }
  addZy: { (eu: Further.EuFullItem, em: Further.EmFullItem): void }
  delZy: { (zy: Further.ZyFullItem): void }
  delEm: { (eu: Further.EuFullItem, em: Further.EmFullItem): void }
  clear: { (): void }
  reset: { (list?: Further.ZyFullItem[]): void }
  undo: { (): void }
  obeyZy: { (zy: Further.ZyFullItem): void }
  sortZyb: { (sortType: number): void }
  adjustmentOrder: { (zy: Further.ZyFullItem, targetIndex: number): void }
  majorIndexChange: { (em: Further.EmFullItem, zy: Further.ZyFullItem, newIndex: number): void }
}

const getFindZy = (eu: Further.EuFullItem, em: Further.EmFullItem, nceeType: number) => {
  return (e: Further.ZyFullItem) => {
    return nceeType === 3 ? e.euInfo.eu_id === eu.eu_id && e.emList[0].em_id === em.em_id : e.euInfo.eu_id === eu.eu_id
  }
}
const scheme: Scheme = {
  /**
   * @description: 获取公共数据
   */
  _getCommonData(): {
    oldList: Further.ZyFullItem[]
    recommendConf: Further.RecommendConf
    zybConf: Further.ZybConf
  } {
    if (!state) {
      state = store.state
      dispatch = store.dispatch
    }
    const oldList: Further.ZyFullItem[] = state.further.provisionalScheme
    const recommendConf: Further.RecommendConf = state.further.currentRecommendConf
    const zybConf: Further.ZybConf = state.further.zyb_conf
    return {
      oldList,
      recommendConf,
      zybConf,
    }
  },
  _commitList: (list: Further.ZyFullItem[], isUndo = false, changeSortType = false): void => {
    if (!state) {
      state = store.state
      dispatch = store.dispatch
    }
    dispatch('further/setProvisionalScheme', {
      list,
      isUndo,
      changeSortType,
    })
  },
  /**
   * @description: 添加志愿
   * @param {Further} eu 招生单位
   * @param {Further} em 招生专业
   * @return {*}
   */
  addZy(eu: Further.EuFullItem, em: Further.EmFullItem): void {
    if (!em) {
      return
    }
    let newList: Further.ZyFullItem[] = []
    const {oldList, recommendConf, zybConf} = this._getCommonData()
    // 在已有的志愿表里查找志愿
    const findZy = getFindZy(eu, em, recommendConf.nceeType)
    const newIndex = oldList.findIndex(findZy)
    const newZy: Further.ZyFullItem =
      newIndex > -1
        ? oldList[newIndex]
        : {
          id: oldList.length + 1,
          subId: 0,
          key: recommendConf.nceeType === 3 ? `${eu.eu_id}_${em.em_id}` : eu.eu_id,
          obey: 1,
          isBackup: 0,
          euInfo: eu,
          emList: [em],
        }
    if (newIndex !== -1) {
      // 已经在志愿表里了就在原志愿项目中加专业
      newZy.emList.push(em)
      newZy.emList = newZy.emList.filter((em) => !!em)
      oldList[newIndex] = newZy
      newList = [...oldList]
      if (newIndex === (oldList.length - 1)) {
        store.commit('further/SET_ISADD', true)
      }
      // if (newZy.emList.length < zybConf.major_no) {
      //
      // } else {
      //   message.warn('已超出可填报专业数量')
      //   return
      // }
    } else {
      store.commit('further/SET_ISADD', true)
      // 如果志愿表里没有这个志愿项目就把志愿项添加到末尾
      if (oldList.length >= zybConf.max_zy_no) {
        message.warn('已超出可填报志愿数量')
        return
      }
      newList = [...oldList, newZy]
    }
    this._commitList(newList)

  },
  /**
   * @description: 删除整个志愿
   * @param {Further} zy
   * @return {*}
   */
  delZy(zy: Further.ZyFullItem, isAllClose = true): void {
    const {oldList} = this._getCommonData()
    const newList: Further.ZyFullItem[] = oldList
      .filter((e) => e.key !== zy.key)
      .map((e, i) => ({
        ...e,
        id: i + 1,
      }))
    if (!isAllClose) {
      if (newList.length === 0) {
        message.warn(`最少保留一个志愿 ! ! !`)
        return
      }
    }

    this._commitList(newList)
  },
  /**
   * @description: 删除单个专业
   * @param eu
   * @param {Further} em
   * @return {*}
   */
  delEm(eu: Further.EuFullItem, em: Further.EmFullItem): void {
    let newList: Further.ZyFullItem[] = []
    const {oldList, recommendConf} = this._getCommonData()
    // 在已有的志愿表里查找志愿
    const findZy = getFindZy(eu, em, recommendConf.nceeType)
    const index = oldList.findIndex(findZy)
    const curZy = oldList.find(findZy)
    if (curZy) {
      if (curZy.emList.length === 1) {
        this.delZy(curZy)
      } else {
        newList = [...oldList]
        newList[index].emList = newList[index].emList.filter((e) => e.em_id !== em.em_id)
        this._commitList(newList)
      }
    }
  },
  /**
   * @description: 清空志愿表
   * @return {*}
   */
  clear(): void {
    const newList: Further.ZyFullItem[] = []

    this._commitList(newList)
  },
  /**
   * @description: 对志愿表的序号进行重新编排
   * @return {*}
   * @param list
   */
  reset(list?: Further.ZyFullItem[]): void {
    let {oldList} = this._getCommonData()
    if (list) {
      oldList = list
    }
    const newList: Further.ZyFullItem[] = oldList.map((e, i) => ({
      ...e,
      id: i + 1,
    }))
    this._commitList(newList, false, !!list)
  },
  /**
   * @description: 上一步回退
   * @return {*}
   */
  undo(): void {
    dispatch('further/goBackDrafts')
  },
  /**
   * @description: 志愿表排序
   * @param {number} sortType 排序依据
   * @return {*}
   */
  sortZyb(sortType: number): void {
    let newList: Further.ZyFullItem[] = []
    const {oldList, recommendConf} = this._getCommonData()
    const {nceeType} = recommendConf
    const sortRank = (a: Further.ZyFullItem, b: Further.ZyFullItem) => a.euInfo.ipin_rank_idx - b.euInfo.ipin_rank_idx
    const sortPlan = (a: Further.ZyFullItem, b: Further.ZyFullItem) => {
      if (nceeType === 3) {
        return b.emList[0].enroll_plan_value - a.emList[0].enroll_plan_value
      } else {
        return b.euInfo.enroll_plan_value - a.euInfo.enroll_plan_value
      }
    }
    const sortRatio = (a: Further.ZyFullItem, b: Further.ZyFullItem) => {
      if (nceeType === 3) {
        return a.emList[0].score_diff
          ? a.emList[0].score_diff - b.emList[0].score_diff
          : a.emList[0].em_ratio_value - b.emList[0].em_ratio_value
      } else {
        return a.euInfo.score_diff
          ? a.euInfo.score_diff - b.euInfo.score_diff
          : a.euInfo.eu_ratio_value - b.euInfo.eu_ratio_value
      }
    }
    // 排序
    oldList.sort((a, b) => {
      if (sortType === 1) {
        // 院校排名排序
        return sortRank(a, b) || sortRatio(a, b) || sortPlan(a, b)
      }
      if (sortType === 2) {
        // 招生人数排序
        return sortPlan(a, b) || sortRatio(a, b) || sortRank(a, b)
      }
      if (sortType === 3) {
        // 录取概率排序
        return sortRatio(a, b) || sortPlan(a, b) || sortRank(a, b)
      }
      return 0
    })
    newList = [...oldList]
    this.reset(newList)
  },
  /**
   * @description: 调整志愿表顺序
   * @param {Further} zy
   * @param {number} targetIndex
   * @return {*}
   */
  adjustmentOrder(zy: Further.ZyFullItem, targetIndex: number): void {
    const {oldList} = this._getCommonData()
    if (zy.id === targetIndex) {
      // 如果点击点编号就是这个志愿的编号
      message.warn(`当前志愿已经在${targetIndex}志愿的位置`)
    } else {
      // 如果不是备选
      let newZyList: Further.ZyFullItem[] = []
      const lastId = zy.id
      zy.id = targetIndex
      zy.subId = 0
      newZyList = oldList.filter((z: Further.ZyFullItem) => z.key !== zy.key)
      if (targetIndex < lastId) {
        for (const z of newZyList) {
          if (z.isBackup === 0) {
            if (z.id >= targetIndex && z.id < lastId) {
              z.id = z.id + 1
            }
          }
        }
      } else {
        for (const z of newZyList) {
          if (z.isBackup === 0) {
            if (z.id <= targetIndex && z.id > lastId) {
              z.id = z.id - 1
            }
          }
        }
      }
      newZyList.push(zy)
      newZyList.sort((a, b) => a.id - b.id)
      this._commitList(newZyList)
    }
  },
  /**
   * @description: 修改志愿是否服从调剂
   * @param {Further} zy
   * @return {*}
   */
  obeyZy(zy: Further.ZyFullItem): void {
    const {oldList} = this._getCommonData()
    if (zy.obey === 1) {
      zy.obey = 0
    } else {
      zy.obey = 1
    }
    oldList[oldList.findIndex((e) => e.key === zy.key)] = zy
    this._commitList([...oldList])
  },
  /**
   * @description: 切换志愿内专业的次序
   * @param {Further} em
   * @param {Further} zyData
   * @param {number} newIndex
   * @return {*}
   */
  majorIndexChange(em: Further.EmFullItem, zyData: Further.ZyFullItem, newIndex: number): void {
    if (!em) {
      return
    }
    const {oldList} = this._getCommonData()
    const oldIndex = zyData.emList.findIndex((e) => e.em_id === em.em_id) + 1
    if (newIndex !== oldIndex) {
      oldList.forEach((zy: Further.ZyFullItem) => {
        if (zyData.euInfo?.eu_id === zy.euInfo.eu_id && zy.emList) {
          const cZy = zy.emList[oldIndex - 1]
          zy.emList.splice(oldIndex - 1, 1)
          zy.emList.splice(newIndex - 1, 0, cZy)
        }
      })
      this._commitList([...oldList], false, true)
    } else {
      message.warn(`已经位于${newIndex === 1 ? '最顶部' : '最底部'}，无法进行移动`)
    }
  },
}
export default scheme
